import React from 'react';
import classNames from 'classnames';

import Locale from 'data/locale';
import EditingContext from 'store/editingContext';
import Accordion from 'ui/accordion';

import './ImportPane.scss';

import ImportSection from './Import';
import ProfilesSection from './Profiles';
import SaveSection from './Save';
import SearchSection from './Search';
import AdUnit from 'AdUnit';

const _L = Locale("ui-import");

function ImportPaneSection({ title, children, expandKey, expanded, setExpanded }) {
  const onClick = React.useCallback(() => setExpanded(prev => prev === expandKey ? null : expandKey), [setExpanded, expandKey]);
  return (
    <div className={classNames("d2p-Section", {"d2p-expanded": expanded === expandKey})}>
      <h3 onClick={onClick}>
        {title}
      </h3>
      <Accordion visible={expanded === expandKey} timing="ease-in-out">
        {children}
      </Accordion>
    </div>
  );
}

export default React.memo(function ImportPane() {
  const [expanded, setExpanded] = EditingContext.useState("importSection", "import");

  return <>
    <div className="d2p-TabContent d2p-ImportPane">
      <ImportPaneSection title={_L`Import`} expandKey="import" expanded={expanded} setExpanded={setExpanded}>
        <ImportSection/>
      </ImportPaneSection>
      <ImportPaneSection title={_L`Save`} expandKey="save" expanded={expanded} setExpanded={setExpanded}>
        <SaveSection/>
      </ImportPaneSection>
      <ImportPaneSection title={_L`Popular Profiles`} expandKey="search" expanded={expanded} setExpanded={setExpanded}>
        <SearchSection/>
      </ImportPaneSection>
      <ImportPaneSection title={_L`My Profiles`} expandKey="profiles" expanded={expanded} setExpanded={setExpanded}>
        <ProfilesSection/>
      </ImportPaneSection>
    </div>
    <AdUnit id="d2planner-tab-save-load" className="d2p-TabFooter d2planner-tab-ad"/>
  </>;
});
